(function() {
    'use strict';

    angular.module('holiday.constants', [])
        .constant('holidayMessagesConst', {
            add: 'Dodano dzień wolny!',
            delete: 'Dzień wolny został usunięty!'
        })
        .constant('holidayPermissionsConst', {
            view: {
                value: 'view_holiday',
                errorMsg: 'Użytkownik nie ma uprawnień do odczytu dni wolnych!'
            },
            add: {
                value: 'add_holiday',
                errorMsg: 'Użytkownik nie ma uprawnień do dodania dni wolnych!'
            },
            update: {
                value: 'change_holiday',
                errorMsg: 'Użytkownik nie ma uprawnień do edycji dni wolnych!'
            },
            delete: {
                value: 'delete_holiday',
                errorMsg: 'Użytkownik nie ma uprawnień do usuwania dni wolnych!'
            }
        });

})();
